const accordionItems = document?.querySelectorAll(".accordion-item");

accordionItems?.forEach((item) => {
  const accordionHeader = item?.querySelector(".accordion-header");
  accordionHeader?.addEventListener("click", function () {
    item?.classList?.toggle("active");
  });
});
